import React, { useMemo } from "react";

const LABELS = ["Too weak", "Weak", "Fair", "Good", "Strong"];
const COLORS = ["bg-rose-400", "bg-rose-400", "bg-amber-400", "bg-brandTeal", "bg-emerald-500"];

function scorePassword(pw) {
  if (!pw) return { score: 0, hits: {} };
  const hits = {
    length8: pw.length >= 8,
    length12: pw.length >= 12,
    upper: /[A-Z]/.test(pw),
    lower: /[a-z]/.test(pw),
    digit: /\d/.test(pw),
    symbol: /[^A-Za-z0-9]/.test(pw),
  };
  let s = 0;
  if (hits.length8) s += 1;
  if (hits.length12) s += 1;
  if (hits.upper && hits.lower) s += 1;
  if (hits.digit) s += 1;
  if (hits.symbol) s += 1;
  return { score: Math.min(s, 4), hits };
}

export default function PasswordStrength({ password, testId = "password-strength" }) {
  const { score, hits } = useMemo(() => scorePassword(password), [password]);
  if (!password) return null;
  return (
    <div className="mt-2" data-testid={testId}>
      <div className="flex gap-1" aria-hidden>
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className={`flex-1 h-1.5 rounded-full transition-colors ${i < score ? COLORS[score] : "bg-slate-200"}`}
          />
        ))}
      </div>
      <div className="flex items-center justify-between mt-1.5">
        <span
          className={`text-xs font-bold ${score >= 3 ? "text-brandTeal" : score >= 2 ? "text-amber-600" : "text-rose-600"}`}
          data-testid={`${testId}-label`}
        >
          {LABELS[score]}
        </span>
        <span className="text-[11px] text-slate-500">
          {hits.length8 ? "8+ chars" : "8+ chars"}
          {" · "}
          {hits.upper && hits.lower ? "Aa" : "Aa"}
          {" · "}
          {hits.digit ? "123" : "123"}
          {" · "}
          {hits.symbol ? "!#?" : "!#?"}
        </span>
      </div>
      <div className="mt-1.5 flex flex-wrap gap-1 text-[11px]" data-testid={`${testId}-hints`}>
        <span className={hits.length8 ? "text-emerald-600" : "text-slate-400"}>{hits.length8 ? "✓" : "○"} 8+ characters</span>
        <span className={hits.upper && hits.lower ? "text-emerald-600" : "text-slate-400"}>{hits.upper && hits.lower ? "✓" : "○"} Upper &amp; lower</span>
        <span className={hits.digit ? "text-emerald-600" : "text-slate-400"}>{hits.digit ? "✓" : "○"} Number</span>
        <span className={hits.symbol ? "text-emerald-600" : "text-slate-400"}>{hits.symbol ? "✓" : "○"} Symbol</span>
      </div>
    </div>
  );
}
